import { FormSpy } from "react-final-form";
import { useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import get from "lodash/get";
import Icon from "@material-ui/core/Icon";
import React, { useState } from "react";

import AddressModal from "./SelectAddressModal";

// import { useTheme } from "@material-ui/core/styles";
// import Alert from '@material-ui/lab/Alert'
// import Grid from '@material-ui/core/Grid'
// import IconButton from '@material-ui/core/IconButton'

function DeliveryInfo(props) {
  // const theme = useTheme()
  const account = useSelector((state) => state.create_order.account);
  const address_book = useSelector((state) => state.create_order.address_book);

  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const findSelectAddress = (selected_id) => {
    return address_book.find((item) => item._id === selected_id) || {};
  };

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values, form: { mutators } }) => {
        const selectedAddress = findSelectAddress(values.shipping_address);
        return (
          <>
            <AddressModal
              type="address"
              open={modalOpen}
              handleCloseModal={handleCloseModal}
              address_book={address_book}
              selected={selectedAddress}
              onSubmit={mutators.setShippingAddress}
            />
            <Box mt={1} mb={2}>
              <Box fontWeight="bold" mb={1}>
                Shipping Address:
              </Box>
              <Box display="flex">
                <Box component={Icon} color="secondary.light" mr={1}>
                  person
                </Box>
                <Box>
                  {get(account, "first_name", "") +
                    " " +
                    get(account, "last_name", "")}
                </Box>
              </Box>
              <Box mt={1} display="flex">
                <Box component={Icon} color="secondary.light" mr={1}>
                  room
                </Box>
                <Box color="text.secondary">{`${get(
                  selectedAddress,
                  "line1"
                )}, ${get(selectedAddress, "sub_district")}, ${get(
                  selectedAddress,
                  "district"
                )}, ${get(selectedAddress, "province")}, ${get(
                  selectedAddress,
                  "postal_code"
                )} `}</Box>
              </Box>
              <Box mt={1} mb={2} display="flex">
                <Box component={Icon} color="secondary.light" mr={1}>
                  phone
                </Box>
                <Box color="text.secondary">
                  {get(selectedAddress, "phone_number")}
                </Box>
              </Box>
              <Button
                variant="contained"
                fullWidth
                size="small"
                disableElevation
                onClick={handleOpenModal}
              >
                EDIT ADDRESS
              </Button>
            </Box>
          </>
        );
      }}
    </FormSpy>
  );
}

export default DeliveryInfo;
